/**
 * @file TrackerShowcase.jsx
 * @description The free Pay & Hours tracker, as real screenshots (sample provider, invented agencies, clients by
 *   initials) in the shared ProductShowcase frame: overview, calendar, payments, expenses, reports. Shown on the home
 *   page, the ABA Case Finder page and the Pay Tracker page. Images in public/marketing/provider (WebP, 2x).
 *   mobileHideTabs: tab ids to leave out on phones (the week calendar is the hardest to read at that size).
 * @module components/TrackerShowcase
 */
import ProductShowcase from "./ProductShowcase";
import { DollarIcon, CalendarIcon, CreditCardIcon, TrendingUpIcon, FileTextIcon } from "./Icons";

const shot = (id, Icon, file, phoneX = 0.14) => ({
  id, key: id, Icon, src: `/marketing/provider/${file}.webp`, w: 1960, h: 1225, fit: "cover", phoneX,
  labelKey: `trackerShowcase.tab.${id}`, captionKey: `trackerShowcase.caption.${id}`, altKey: `trackerShowcase.alt.${id}`,
});

export const TRACKER_TABS = [
  shot("overview", DollarIcon, "tracker-overview"),
  shot("calendar", CalendarIcon, "tracker-calendar"),
  shot("payments", CreditCardIcon, "tracker-payments"),
  shot("expenses", TrendingUpIcon, "tracker-expenses"),
  shot("reports", FileTextIcon, "tracker-reports"),
];

export default function TrackerShowcase({ isMobile, accent, mobileHideTabs = [] }) {
  const tabs = isMobile ? TRACKER_TABS.filter(tb => !mobileHideTabs.includes(tb.id)) : TRACKER_TABS;
  return <ProductShowcase isMobile={isMobile} accent={accent} tabs={tabs} sampleTag testId="tracker-showcase" />;
}
